import { useState, useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import './Navbar.css'

const MenuIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
  </svg>
)

const CloseIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
)

const ChevronIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
    <path d="M7 10l5 5 5-5z" />
  </svg>
)

const primaryLinks = [
  { to: '/radio', label: 'Radio' },
  { to: '/planning', label: 'Planning' },
  { to: '/dedicaces', label: 'Dédicaces' },
  { to: '/request', label: 'Request' },
]

const moreLinks = [
  { to: '/equipe', label: 'Équipe' },
  { to: '/integrations', label: 'Intégrations' },
  { to: '/contact', label: 'Contact' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  // Fermer tout au changement de route
  useEffect(() => {
    setMenuOpen(false)
    setDropdownOpen(false)
  }, [location])

  // Fermer le dropdown au clic extérieur (desktop)
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const isMoreActive = moreLinks.some(l => location.pathname === l.to)

  return (
    <>
      {menuOpen && <div className="navbar__overlay" onClick={() => setMenuOpen(false)} />}
      <nav className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
        <div className="navbar__inner">
          <NavLink to="/" className="navbar__logo">
            <img src="/favicon.svg" alt="" width="28" height="28" aria-hidden="true" />
            <span>StellarFM</span>
          </NavLink>

          <ul className={`navbar__links${menuOpen ? ' navbar__links--open' : ''}`}>
            {primaryLinks.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) => isActive ? 'navbar__link navbar__link--active' : 'navbar__link'}
                >
                  {label}
                </NavLink>
              </li>
            ))}

            {/* ── Desktop dropdown "Plus" ── */}
            <li className="navbar__more" ref={dropdownRef}>
              <button
                className={`navbar__more-btn${isMoreActive ? ' navbar__link--active' : ''}`}
                onClick={() => setDropdownOpen(v => !v)}
                aria-expanded={dropdownOpen}
              >
                Plus
                <span className={`navbar__chevron${dropdownOpen ? ' navbar__chevron--open' : ''}`}>
                  <ChevronIcon />
                </span>
              </button>

              {dropdownOpen && (
                <ul className="navbar__dropdown">
                  {moreLinks.map(({ to, label }) => (
                    <li key={to}>
                      <NavLink
                        to={to}
                        className={({ isActive }) => isActive ? 'navbar__dropdown-link navbar__dropdown-link--active' : 'navbar__dropdown-link'}
                      >
                        {label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>

            {/* ── Mobile-only secondary links (flat, after separator) ── */}
            <li className="navbar__mobile-sep" aria-hidden="true" />
            {moreLinks.map(({ to, label }) => (
              <li key={`m-${to}`} className="navbar__mobile-secondary">
                <NavLink
                  to={to}
                  className={({ isActive }) => isActive ? 'navbar__link navbar__link--active' : 'navbar__link'}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="navbar__right">
            <button className="navbar__menu-btn" onClick={() => setMenuOpen(v => !v)} aria-label="Menu">
              {menuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>
      </nav>
    </>
  )
}
